module.exports = __webpack_public_path__ + "img/6.979cf664.jpeg";